import './SignUp.css';
import * as AppConfig from '../../app/config/constants'
import Button from '../../components/elements/Button';
import Input from '../../components/elements/Input';
import PopupModal from '../../components/templates/PopupModal';
import React, {Fragment} from 'react';
import SidebarLayout from '../../components/templates/SidebarLayout.js';
import axios from 'axios';
import useAuthApi from "../../hooks/useAuthApi";
import { useHistory } from "react-router-dom";
import { useState, useEffect, useRef } from 'react';
import AuthApi from "../../utils/api/AuthApi";

function SignUp(props) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  // TODO: Remove this once we have an actual consent form
  const [consented, setConsented] = useState(true);
  const [emailIsValid, setEmailIsValid] = useState(null);
  const [passwordIsValid, setPasswordIsValid] = useState(null);
  const [passwordConfirmationIsValid, setPasswordConfirmationIsValid] = useState(null);
  const [accessCode, setAccessCode] = useState('');
  const [currentPage, setCurrentPage] = useState('form');
  const [accessCodeIsValid, setAccessCodeIsValid] = useState(null);
  const [accessCodeResent, setAccessCodeResent] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState('Please enter a valid email address.');
  const [userExists, setUserExists] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [userId, setUserId] = useState(null)

  const history = useHistory();
  const authApi = useAuthApi();

  function onSubmit(e) {
    e.preventDefault();
    if (currentPage == 'form') {
      createUser();
    } else if (currentPage == 'confirmation') {
      setAccessCodeIsValid(null);
      confirmUser();
    }
    
  }

  function switchPage(page) {
    setCurrentPage(page);
    window.scrollTo(0, 0);
    setPasswordConfirmationIsValid(null);
    setPasswordIsValid(null);
    setPassword('');
    setPasswordConfirmation('');
    setFirstName('')
    setLastName('')
    setEmail('')
    if (showModal) {
      closeModal()      
    }
  }

  function goToSignIn() {
    history.push({
      pathname: '/signin',
      state: { from_sign_up: true }
    })
  }

  function deleteAccountHandler() {
    authApi.delete('users/users/' + userId + '/destroy_unconfirmed_user').then(() => {
      switchPage('form');
      window.scrollTo(0, 0);
    }).catch(console.log);
  }

  const createUser = () => {
    new AuthApi(null).post_form_encoded('signup',{
        user: {
          email: email,
          password: password,
          password_confirmation: passwordConfirmation,
          hipaa_consented: consented
        },

        user_information: {
          first_name: firstName,
          last_name: lastName
        }
      }).then(data => {
        setUserId(data.data.id)
        switchPage('confirmation');
      }).catch(function(error) {
        const errors = error?.response?.data?.errors;
        const emailExists = (errors || []).some(e => e.detail === 'Email already exists.');
        if (emailExists) {
          const emailExistsError = <span>There is already an account associated with that email. <a href='/signin'><u>Log in here.</u></a></span>
          setEmailErrorMessage(emailExistsError);
          setUserExists(true);
        }
      });
  }

  const confirmUser = () => {
    new AuthApi(null).get('confirmation', {
      email: email,
      confirmation_token: accessCode
    }).then(data => {
      setAccessCodeIsValid(true);
      goToSignIn();
    }).catch(error => {
      console.log(error);
      setAccessCodeIsValid(false);
      setAccessCodeResent(false);
    });
  }

  const resendAccessCode = () => {
    const URL = AppConfig.AUTH_API_BASE_URI + 'confirmation';
    axios.post(URL, {
          user: {
            email: email
          }
        })
      .then(res => { 
        setAccessCodeResent(true);
      });
  }

  function closeModal () {
    setShowModal(false)
  }
  function validateName() {
    return firstName != '' && lastName != '';
  }

  function validateEmail() {
    const validEmail = String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    if (email == '') {
      return null;
    } else {
      return validEmail != undefined;
    }
  }

  function validatePassword() {
    
    if (password == '') {
      return null
    } else {
      const uppercaseRegExp   = /(?=.*?[A-Z])/;
      const lowercaseRegExp   = /(?=.*?[a-z])/;
      const digitsRegExp      = /(?=.*?[0-9])/;
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
      const minLengthRegExp   = /.{12,}/;
      const passwordLength =      password.length;

      const uppercasePassword =   uppercaseRegExp.test(password);
      const lowercasePassword =   lowercaseRegExp.test(password);
      const digitsPassword =      digitsRegExp.test(password);
      const specialCharPassword = specialCharRegExp.test(password);
      const minLengthPassword =   minLengthRegExp.test(password);

      return uppercasePassword && specialCharPassword && minLengthPassword
    }
  }

  function validatePasswordConfirmation() {
    if (passwordConfirmation == '') {
      return null
    } else {
      return password != '' && passwordConfirmation != '' && password == passwordConfirmation;
    }
  }

  function handleAccessCodeChange(val) {
    setAccessCode(val);

    if (val == '') {
      setAccessCodeIsValid(null);
      setAccessCodeResent(false);
    }
  }

  function handleEmailChange(val) {
    setEmail(val);

    if (val == '') {
      setEmailIsValid(null);
      setEmailErrorMessage('Please enter a valid email address.');
      setUserExists(false);
    }
  }

  const SignUpForm = () => {
    return (
      <React.Fragment>
        <p className='body-2'>Step 1 of 2</p>
        <h1>We’re glad you’re here!</h1>
        <p className="sign-up__subtitle">To make sure it’s you, enter your name and work email. We’ll get to the personal stuff later.</p>

        <form id='sign-up-form' onSubmit={(e) => onSubmit(e)} noValidate>
          <Input
            placeholder="First name"
            name="first-name"
            label="First name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            inputContainerClasses='sign-up-form__input'
            showArrow={false}
            readOnly={false}
          />

          <Input
            placeholder="Last name"
            name="last-name"
            label="Last name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            inputContainerClasses='sign-up-form__input'
            showArrow={false}
            readOnly={false}
          />

          <Input
            placeholder="Work email"
            name="work-email"
            label="Work email"
            value={email}
            onChange={(e) => handleEmailChange(e.target.value)}
            onBlur={(e) => setEmailIsValid(validateEmail())}
            inputContainerClasses='sign-up-form__input '
            showArrow={false}
            readOnly={false}
            errorMessage={emailErrorMessage}
            showErrorMessage={(email != '' && emailIsValid == false) || userExists}
            showErrorIcon={true}
          /> 

          <Input
            placeholder="Password"
            type="password"
            name="password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onBlur={(e) => setPasswordIsValid(validatePassword())}
            inputContainerClasses='sign-up-form__input with-help-text'
            showArrow={false}
            readOnly={false}
            helpText="Passwords must be at least 12 characters, including 1 uppercase letter and 1 symbol."
            errorMessage="Please use at least 12 characters, including 1 uppercase letter and 1 symbol."
            validMessage="Passwords match."
            showErrorMessage={password != '' && passwordIsValid == false}
            showValidMessage={passwordIsValid == true && passwordConfirmationIsValid == true}
            showErrorIcon={true}
          /> 

          <Input
            placeholder="Re-enter Password"
            type="password"
            name="password-confirmation"
            label="Re-enter Password"
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            onFocus={(e) => setPasswordConfirmationIsValid(validatePasswordConfirmation())}
            onBlur={(e) => setPasswordConfirmationIsValid(validatePasswordConfirmation())}
            inputContainerClasses='sign-up-form__input with-help-text'
            showArrow={false}
            readOnly={false}
            errorMessage="Passwords do not match. Please re-enter."
            validMessage="Passwords match."
            showErrorMessage={passwordConfirmation != '' && passwordConfirmationIsValid == false}
            showValidMessage={passwordIsValid == true && passwordConfirmationIsValid == true}
            showErrorIcon={true}
          /> 

          <Button 
            label="Next: Security Code"
            active={validateName() && validateEmail() && validatePassword() && validatePasswordConfirmation()}
            class="long-btn filled"
          />
        </form>
      </React.Fragment>
    );
  }

  const EmailConfirmation = () => {
    const accessCodeResendHelper = accessCodeResent ? <p className='access-code-helper sent'>Code sent! This may take a few mins.</p> : <a className='sign-up-form__link access-code-helper' onClick={(e) => resendAccessCode()}>Resend my code.</a>
    return(
      <React.Fragment>
        <PopupModal noPadding show={showModal} close={closeModal} size="md" dialogClassName="my-modal" position="centered" 
        body={<div className="sign-up__modal-body">
          <p className="sign-up__modal-header">Are you sure you want to go back?</p>
          <p className='sign-up__modal-text'>This will delete any progress you’ve made in creating your account.</p> 
          <Button 
            label="Go Back"
            active={true}
            class="outline-btn-blue"
            onClick={()=> deleteAccountHandler()}
          />  
          <Button 
            label="Cancel"
            active={true}
            class="long-btn text-btn"
            onClick={()=> setShowModal(false)}
          /></div>}/>
        <p className='body-2 pointer' onClick={() => setShowModal(true)}><span className='back-arrow' /> Step 2 of 2</p>
        <h1>Check your work email.</h1>
        <p className="sign-up__subtitle">At Handl Health, we prioritize your security. Anytime you log-in, we’ll send you an access code. No password breaches over here.</p>

        <form id='email-confirmation-form' onSubmit={(e) => onSubmit(e)} noValidate>
          <Input
            placeholder="Access Code"
            name="access-code"
            label="Access Code"
            value={accessCode}
            onChange={(e) => handleAccessCodeChange(e.target.value)}
            inputContainerClasses='access-code__input'
            showArrow={false}
            readOnly={false}
            helpText="Your unique access code will expire in 5 minutes."
            errorMessage="Hmm, that isn't the code we sent you."
            validMessage="Valid code."
            showErrorMessage={accessCodeIsValid == false}
            showValidMessage={accessCodeIsValid == true}
            showErrorIcon={true}
          />

          <Button 
            label="Build My Profile"
            active={accessCode != ''}
            class="long-btn filled build-profile-btn"
          />

          <div className='access-code-helper-container'>
            {accessCodeResendHelper}
          </div>


        </form>
      </React.Fragment>
    )
  }

  const SideBar = (page) => {
    var topText;
    var bottomText;
    var image;

    if (page == 'form') {
      topText = "You’ve got health benefits (woot!).";
      bottomText = "We’ll help you use them.";
      image = "https://storage.googleapis.com/handlhealth/Powerful-rafiki%201.svg"
    } else {
      topText = "Next up, full-service concierge health benefits.";
      bottomText = "Just for you.";
      image = "https://storage.googleapis.com/handlhealth/Finish%20line-bro%201.svg"
    }

    return(
      <React.Fragment>
        <div className='sign-up__side-bar-text'>
          <h2>{topText}</h2>
          <h2>{bottomText}</h2>
        </div>
        <img src={image} />
      </React.Fragment>
    )
  }

  return (
    <SidebarLayout 
      sidebar={SideBar(currentPage)}
      sidebarClasses='sign-up__side-bar'
      content={currentPage == 'form' ? SignUpForm() : EmailConfirmation()}
      contentClasses='sign-up__content'
      userStatus='logged-out'
      showFooter={false}
    />
  )
}

export default SignUp;
